import { LoadingOverlay, Box, Flex, Text } from '@mantine/core';

import { typedEntries } from '@/shared/utils/helpers/common';
import { paymentsStatsTitles } from '../../utils/const/common';

import type { TPaymentsStats } from '../../store/types';

type Props = {
  data?: TPaymentsStats;
  isLoading?: boolean;
};

export const PaymentsStatsContent = (props: Props) => {
  const {
    data,
    isLoading,
  } = props;

  return (
    <Box style={{ position: 'relative' }}>
      <LoadingOverlay
        visible={isLoading}
        overlayProps={{ blur: 2 }}
      />

      {data && typedEntries(data).map(([name, value]) => (
        <Flex justify={'space-between'} mb={5} style={{ borderBottom: '1px solid #ddd' }}>
          <Text>{paymentsStatsTitles[name]}</Text>
          <Text fw={'bold'}>{value}</Text>
        </Flex>
      ))}
    </Box>
  );
};
